// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__5R_sM","blue":"Badge_blue__ihkUF","yellow":"Badge_yellow__yY7Xu","green":"Badge_green__19ym_","grey":"Badge_grey__jaJGf","red":"Badge_red__LjnR5"};